import firebase from 'firebase'
import store from '../store'
import moment from 'moment'

export function funcGetDataFromFirebase (uid) {
  return new Promise((resolve, reject) => {
    const colref = firebase.firestore().collection('users')
    colref.doc(uid).get()
      .then((doc) => {
        /* 既存ユーザの場合 */
        if (doc.exists) {
          resolve(doc.data())
        }
        /* 初回ユーザの場合 */
        resolve({})
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function funcSetDataToFirebase () {
  const sendData = {
    uid: store.state.user.uid,
    shikakuList: store.state.user.shikakuList,
    studyList: store.state.user.studyList,
    kininaruList: store.state.user.kininaruList,
    taskList: store.state.user.taskList,
    darkMode: store.state.darkMode,
    lastUpdate: moment().format(),
  }
  const colref = firebase.firestore().collection('users')
  colref.doc(store.state.user.uid).set(sendData)
    .then(function (docRef) {
      return 0
    })
    .catch(function (error) {
      console.error('Failed to add document to firebase.', error)
      return 1
    })
}

export function funcGetPublicProfile (token) {
  return new Promise((resolve, reject) => {
    firebase.firestore().collection('public_profiles').doc(token).get()
      .then((doc) => {
        if (doc.exists) {
          resolve(doc.data())
        } else {
          resolve(null)
        }
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function funcSetPublicProfile (token, data) {
  return firebase.firestore().collection('public_profiles').doc(token).set(data)
}

export function funcDeletePublicProfile (token) {
  return firebase.firestore().collection('public_profiles').doc(token).delete()
}

export function funcLoggingToFirebase (logdata) {
  const sendData = {
    uid: store.state.user.uid,
    date: new Date(),
    log: logdata,
  }
  const colref = firebase.firestore().collection('logs')
  colref.doc().set(sendData)
    .then(function (docRef) {
      return 0
    })
    .catch(function (error) {
      console.error('Failed to add document to firebase.', error)
      return 1
    })
}
